"use client";

/**
 * Deliberate crash trigger for testing the error boundaries end to end
 * (boundary catch → app.crash telemetry → auto-reload → recovery card).
 *
 * Inert unless the URL contains ?crashtest=1 — real users never hit this.
 * ?crashtest=1 throws after mount (client render crash, like React #185);
 * the auto-reload strips nothing, so the second mount throws again inside
 * the loop window, which exercises the fallback card path too.
 */

import { useEffect, useState } from "react";

export function CrashTest() {
  const [armed, setArmed] = useState(false);

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      if (params.get("crashtest") === "1") setArmed(true);
    } catch {
      // never let the test hook itself break anything
    }
  }, []);

  if (armed) {
    throw new Error("XynthCrashTest: deliberate crash via ?crashtest=1");
  }
  return null;
}
